import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';

import SavedViewUpdatesAggRootQueryNode, {
	type SavedViewUpdatesAggRootQuery,
} from '../SavedViewUpdates/agg/__generated__/SavedViewUpdatesAggRootQuery.graphql';

export const savedViewUpdatesAggResource: RouteResource<
	PreloadedQuery<SavedViewUpdatesAggRootQuery, Record<string, unknown>>
> = createRelayResource<SavedViewUpdatesAggRootQuery>({
	getQuery: (routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;
		const directoryId = routerContext.match.params.uuid || '';
		const shouldFetchGoalsData = context.townsquareApp !== 'projects';
		const shouldFetchProjectsData = context.townsquareApp !== 'goals';

		return {
			query: SavedViewUpdatesAggRootQueryNode,
			variables: {
				containerId: context.collabContext?.contextId || '',
				directoryId,
				viewUuid: directoryId,
				shouldFetchGoalsData,
				shouldFetchProjectsData,
			},
			options: {
				fetchPolicy: 'store-and-network',
			},
			environment: getAggRelayEnvironment(),
		};
	},
});
